<template>
    <div v-if="!isBuyForWoman">
        <div class="box-data">
            <h3 class="title-content">{{ $t('CAN_I_USE_BRASTER') }}</h3>
            <BrasterAllowed />
        </div>
        <div id="CzynnikiRyzyka" class="box-data">
            <h3 class="title-content">{{ $t('RISK_FACTORS') }}</h3>
            <RiskFactors />
        </div>
        <div id="DaneMedyczne" class="box-data">
            <h3 class="title-content">{{ $t('MEDICAL_DATA') }}</h3>
            <MedicalData />
        </div>
        <div id="DanePersonalne" class="box-data">
            <h3 class="title-content">{{ $t('PERSONAL_DATA') }}</h3>
            <PersonalData />
        </div>
        <div id="DodatkoweInformacje" class="box-data">
            <h3 class="title-content">{{ $t('ADDITIONAL_MEDICAL_DATA') }}</h3>
            <AdditionalDocument />
        </div>
    </div>
</template>

<script>
import BrasterAllowed from './braster-allowed.vue';
import RiskFactors from './risk-factors.vue';
import MedicalData from './medical-data.vue';
import PersonalData from './personal-data.vue';
import AdditionalDocument from './additional-document.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        BrasterAllowed,
        RiskFactors,
        MedicalData,
        PersonalData,
        AdditionalDocument,
    },
    computed: {
        ...mapGetters(['survey']),
        isBuyForWoman() {
            return this.survey.accountStage === 'BUY_FOR_WOMEN';
        },
    },
};
</script>

<style>
.box-data {
    border: 1px solid #ede8e4;
    padding: 20px;
    margin-bottom: 20px;
}

.box-data:last-child {
    margin-bottom: 0;
}

span.disabled {
    background: none;
    border: none;
    cursor: default;
    font-weight: 700;
    font-size: 18px;
    padding: 5px 0 0 0;
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// my-medical-data.vue?30353448